import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { AxnRelyingParty, SimpleAxnWorkflow } from "@idw-types/data/reference-data/axn";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { mapEntitiesWithNameAndIdToSelectOptions, mapRpServiceToSelectOption } from "@utils/select-option-mapping-util";
import { sortStrings } from "@utils/string-util";

export const getRpServiceOptionsForCompanyAndRelyingParty = (validServices: Array<RpServiceConfiguration>, relyingParties: Array<AxnRelyingParty>, selectedCompanyOption: SelectOption, selectedRelyingPartyOption: SelectOption): Array<SelectOption> => {
    const validRelyingPartyIds = getRelyingPartyIds(relyingParties, selectedCompanyOption, selectedRelyingPartyOption);

    return validServices.reduce((finalRpServices, service) => {
        if (validRelyingPartyIds.includes(service.relyingPartyID) && !!service.id) {
            finalRpServices.push(mapRpServiceToSelectOption(service));
        }

        return finalRpServices;
    }, [] as Array<SelectOption>).sort((a, b) => sortStrings(a.label, b.label));
}

export const getRelyingPartyOptions = (relyingParties: Array<AxnRelyingParty>, selectedCompanyOption: SelectOption) => {
    if (selectedCompanyOption !== null) {
        const availableRelyingParties = relyingParties.filter(rp => rp.companyID === selectedCompanyOption.value);
        return mapEntitiesWithNameAndIdToSelectOptions(availableRelyingParties).sort((a, b) => sortStrings(a.label, b.label));
    } else {
        return mapEntitiesWithNameAndIdToSelectOptions(relyingParties).sort((a, b) => sortStrings(a.label, b.label));
    }
}

export const getRelyingPartyIds = (relyingParties: Array<AxnRelyingParty>, selectedCompanyOption: SelectOption, selectedRelyingPartyOption: SelectOption): Array<string> => {
    if (selectedRelyingPartyOption !== null) {
        return relyingParties.reduce((rpids, rp) => {
            if (rp.id === selectedRelyingPartyOption.value) {
                rpids.push(rp.id);
            }

            return rpids;
        }, []);

    } else if (selectedCompanyOption !== null) {
        return relyingParties.reduce((rpids, rp) => {
            if (rp.companyID === selectedCompanyOption.value) {
                rpids.push(rp.id);
            }

            return rpids;
        }, []);
    } else {
        return relyingParties.map(rp => rp.id);
    }

}

export const getWorkflowOptionsForCompanyAndRelyingParty = (workflows: Array<SimpleAxnWorkflow>, selectedCompanyOption: SelectOption, selectedRelyingPartyOption: SelectOption) => {

    if (selectedRelyingPartyOption !== null) {
        const availableWorkflows = workflows.filter(workflow => workflow.relyingPartyID === selectedRelyingPartyOption.value);
        return mapEntitiesWithNameAndIdToSelectOptions(availableWorkflows).sort((a, b) => sortStrings(a.label, b.label));
    } else if (selectedCompanyOption !== null) {
        const availableWorkflows = workflows.filter(workflow => workflow.companyID === selectedCompanyOption.value);
        return mapEntitiesWithNameAndIdToSelectOptions(availableWorkflows).sort((a, b) => sortStrings(a.label, b.label));
    } else {
        return mapEntitiesWithNameAndIdToSelectOptions(workflows).sort((a, b) => sortStrings(a.label, b.label));
    }
}